import { request } from './request'

export interface DashboardDataPoint {
  label: string
  value: number
}

export interface DashboardStoreRankItem {
  storeId: string
  storeName: string
  orderCount: number
  revenue: number
  avgPrice: number
}

export interface DashboardHotProductItem {
  productId: string
  productName: string
  sales: number
  salesAmount: number
}

export interface DashboardOverview {
  todayOrderCount: number
  todayRevenue: number
  todayRechargeAmount: number | null
  monthRevenue: number
  pendingOrderCount: number
  pendingRefundCount: number
  totalUsers: number
  totalStores: number
  trend: DashboardDataPoint[]
  statusDistribution: DashboardDataPoint[]
  storeRank: DashboardStoreRankItem[]
  hotProducts: DashboardHotProductItem[]
}

export const dashboardApiReady = true as const

export const fetchDashboardOverview = async (): Promise<DashboardOverview> =>
  request<DashboardOverview>({
    url: '/dashboard/overview',
    method: 'GET',
  })
